export interface User {
  id: string;
  username: string;
  displayName: string;
  avatar: string;
  avatarColor: string;
  initials: string;
  rank: number;
  previousRank: number;
  score: number;
  messages: number;
  activeDays: number;
  groups: number;
  streak: number;
  weeklyGrowth: number;
  bestDay: string;
  mostActiveHour: string;
  joinedDate: string;
  badges: string[];
}

export interface Achievement {
  id: string;
  userId: string;
  username: string;
  displayName: string;
  avatarColor: string;
  initials: string;
  title: string;
  description: string;
  stat: string;
  statLabel: string;
  category: string;
  unlockedAt: string;
  icon: string;
  rarity: 'legendary' | 'epic' | 'rare' | 'common';
  featured: boolean;
}

export interface ShameEntry {
  id: string;
  userId: string;
  username: string;
  displayName: string;
  avatarColor: string;
  initials: string;
  category: string;
  categoryIcon: string;
  stat: string;
  statLabel: string;
  description: string;
  period: string;
}

export const USERS: User[] = [];

export const ACHIEVEMENTS: Achievement[] = [];

export const ACTIVITY_DATA = [
  { date: 'Jul 24', messages: 3820, users: 89 },
  { date: 'Jul 25', messages: 4210, users: 94 },
  { date: 'Jul 26', messages: 2940, users: 71 },
  { date: 'Jul 27', messages: 5130, users: 112 },
  { date: 'Jul 28', messages: 6740, users: 128 },
  { date: 'Jul 29', messages: 7890, users: 141 },
  { date: 'Jul 30', messages: 5210, users: 103 },
  { date: 'Jul 31', messages: 4680, users: 98 },
  { date: 'Aug 1', messages: 6120, users: 119 },
  { date: 'Aug 2', messages: 5490, users: 107 },
  { date: 'Aug 3', messages: 7230, users: 134 },
  { date: 'Aug 4', messages: 8910, users: 156 },
  { date: 'Aug 5', messages: 6340, users: 121 },
  { date: 'Aug 6', messages: 4890, users: 99 },
  { date: 'Aug 7', messages: 9120, users: 167 },
  { date: 'Aug 8', messages: 7840, users: 148 },
  { date: 'Aug 9', messages: 6210, users: 118 },
  { date: 'Aug 10', messages: 8430, users: 152 },
  { date: 'Aug 11', messages: 10240, users: 178 },
  { date: 'Aug 12', messages: 9180, users: 163 },
  { date: 'Aug 13', messages: 7640, users: 139 },
  { date: 'Aug 14', messages: 8920, users: 159 },
  { date: 'Aug 15', messages: 11340, users: 192 },
  { date: 'Aug 16', messages: 9870, users: 171 },
  { date: 'Aug 17', messages: 8210, users: 147 },
  { date: 'Aug 18', messages: 12490, users: 204 },
  { date: 'Aug 19', messages: 10830, users: 188 },
  { date: 'Aug 20', messages: 9340, users: 162 },
  { date: 'Aug 21', messages: 11780, users: 197 },
  { date: 'Aug 22', messages: 13240, users: 218 },
];

export const COMMUNITY_STATS = {
  totalMessages: 0,
  activeUsers: 0,
  totalGroups: 0,
  messagesThisWeek: 0,
  topScorer: null as User | null,
  fastestRiser: null as User | null,
};

export function getRankMovement(user: User): { delta: number; label: string; direction: 'up' | 'down' | 'new' | 'same' } {
  const delta = user.previousRank - user.rank;
  if (delta > 0) return { delta, label: `↑${delta}`, direction: 'up' };
  if (delta < 0) return { delta: Math.abs(delta), label: `↓${Math.abs(delta)}`, direction: 'down' };
  return { delta: 0, label: '—', direction: 'same' };
}

export function formatNumber(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return n.toString();
}